module.exports = __webpack_public_path__ + "img/files_grey.00fc686f.svg";